export default class Grid {

    constructor(width, height) {
      this.width = width;
      this.height = height;
      this.grid = this.createGrid()
    }
  
    createGrid (){
      const grid = [];
      for (let i = 0; i < this.height; i++) {
        grid[i] = [];
        for (let j = 0; j < this.width; j++) {
          grid[i][j] = false;
        }
      }
      return grid
    }
  
    fillGrid (x, y, width, height) {
      for(let i = 0; i < height; i++) {
        for (let j = 0; j < width; j++) { 
          this.grid[i+y][j+x] = true; 
        }
      }
    }
  
    gridHasEmptySlot ( x, y, w, h) {
      for(let k = y; k < y+h; k++) {
        for (let z = x; z < x+w; z++) { 
          if (this.grid[k][z]) return false
        }
      } 
      return true ;
    }
  
    findEmptySpaceInsideGrid (layout, wantedW, wantedH) {
     
      for (let widget of layout) {
          this.fillGrid(widget.x, widget.y, widget.w, widget.h)
      }
      // Find empty slot
      for(let y=0; y<=this.height-wantedH; y++){
        for(let x=0; x<=this.width-wantedW; x++){
          if (this.gridHasEmptySlot(x, y, wantedW, wantedH)){
            let coordinates = { x, y }
            return coordinates
          }
        }
      }
      // Failed ?
      return null
    }
  
    printGrid(){
      return this.grid.map(line => line.map(v => v ? "1" : "0").join("")).join("\n")
    }
  
  }


// WEBPACK FOOTER //
// ./src/utils/grid.js